import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone'

import { Button } from 'components'
import { Calendar } from 'features';
import { FaChevronDown, FaShare, FaFilter, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';

const Container = styled.div`
    background-color: #474747;
    width: auto;
    height: 100%;
    right: 0;
    padding: 0.5rem 0.5rem;
    box-sizing: border-box;
    margin-bottom: 1rem;
    border-radius: 5px;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
`

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    width: ${props => props.width};
    justify-content: space-between;
`

const Dropdown = styled.div`
    box-sizing: border-box;
    cursor: pointer;
    color: var(--text-color);
    outline: none;
    font-size: 0.9rem;
    padding: 0 0.5rem;
    height: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    vertical-align: middle;
    border-radius: 5px;
    background-color: #2B2B2B;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Icon = styled.div`
    color: var(--secondary-accent-color);
    font-size: var(--icon-size);
    margin: 0 0rem 0 0.3rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
`

const Header = styled.div`
    display: grid;
    grid-template-columns: 1rem 1fr 1rem;
    justify-items: center;
    align-items: center;
    margin-bottom: 0.2rem;
    padding: 0 0.5rem;
`

const HeaderTitle = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 0.3rem;
    font-weight: bolder;
    font-size: 0.8rem;
    align-items: center;
    justify-content: center;
`

const CalendarBlock = props => {
    const {
        events,
        collectRefs
    } = props;
    // console.log('[Events]', events)

    const buttonStyle = {
        backgroundColor: '#474747',
        margin: '0 1px 0 0',
        borderColor: 'transparent',
        fontSize: '0.8rem',
        padding: '0.3rem',
        boxShadowColor: 'transparent'
    }

    const titleStyle = {
        backgroundColor: 'var(--secondary-color)',
        color: 'var(--text-color)',
        margin: 0,
        padding: '0.4rem'
    }
    // console.log(events)
    return (
        <Container>
            {/* Access header */}
            <Header>
                <span/>
                {/* <Button icon={<FaInfoCircle/>} styles={this.buttonStyle} contextMenu={<div>Info here</div>}/> */}
                <Button icon={<HeaderTitle>Calendar<FaChevronDown/></HeaderTitle>} iconOnly styles={titleStyle}/>
                <Button icon={<FaTimes/>} styles={buttonStyle} onSelect={() => {}}/>
            </Header>

            {/* Date title */}
            <Wrapper width='100%'>                
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Dropdown>
                        <div>Day</div>
                        <Icon><FaChevronDown/></Icon>
                    </Dropdown>

                    <Button icon={<FaShare/>} tooltip='Forward incomplete items to the next day' onSelect={() => {}} styles={buttonStyle}/>
                </div>
                
                <Wrapper>
                    <Button icon={<div style={{fontSize: '0.8rem'}}>{moment().format('ddd, D MMM Y')}</div>} placement='bottom' styles={buttonStyle}/>

                    <Button iconOnly icon={<FaFilter/>} styles={buttonStyle} onSelect={() => {}} tooltip='Filter'/>
                    <Button iconOnly icon={<FaChevronLeft/>} styles={buttonStyle} onSelect={() => {}} tooltip={`Prev day`}/>
                    <Button iconOnly icon={<FaChevronRight/>} styles={buttonStyle} onSelect={() => {}} tooltip={`Next day`}/>
                </Wrapper>
            </Wrapper>

            <Calendar view='day' disableDND date={moment().set({hour: 8, minute: 0, second: 0})} getNow={() => (moment().set({hour: 8, minute: 0, second: 0}).toDate())} 
                events={events} onSchedule={() => {}} collectRefs={collectRefs}
                scrollToTime={moment().set({hour: 8, minute: 0, second: 0}).toDate()}
                animate/>
        </Container>
    )
}

export default CalendarBlock